import styled from 'styled-components';

const backgroundPosition = ({align}) => {
  switch (align) {
    case 'lt':
      return 'left top';
    case 'lc':
      return 'left center';
    case 'lb':
      return 'left bottom';

    case 'rt':
      return 'right top';
    case 'rc':
      return 'right center';
    case 'rb':
      return 'right bottom';

    case 'ct':
      return 'center top';
    case 'cc':
      return 'center center';
    case 'cb':
      return 'center bottom';

    default:
      return align;
  }
};

export const StyledBackgroundImg = styled.div`
  background-image: url(${props => props.src});
  background-position: ${backgroundPosition};
  background-size: cover;
  width: 100%;
  height: 100%;

  & > img {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  }

  @media print {
    height: auto;
    overflow: hidden;

    & > img {
      position: static;
      overflow: visible;
      clip: unset;
      width: 100%;
      height: auto;
      margin: 0;
      display: block;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/elements/util/BackgroundImg/styled.js